import { CLINIC_NAMES } from "./constants";

export const CARDIO_CHECK_ACCOUNTS = [
  "Bayonet Point Hudson Cardiology",
  "Holiday Heart and Vascular",
  "Florida Heart Institute",
  "Florida Cardiology Group",
  "Cardiovascular Clinic",
  "West Coast Arrhythmia Center",
  "Tampa Cardiovascular Associates",
  "Advanced Heart & Vascular Associates",
  "Bond Clinic",
  "Comprehensive Cardiovascular",
  "South Shore Cardiovascular Associates",
  "Premier Cardiology & Vascular Associates",
  "Premier Heart and Vascular Center",
  "Cardiology Physicians Daytona",
  "Sunshine Cardiovascular & Vein",
  "Florida Medical Clinic",
  "South Tampa Cardiology",
  "University of Toledo",
];

export const COVENANT_ACCOUNTS = [
  CLINIC_NAMES.CAET,
  CLINIC_NAMES.PARKWAY,
  CLINIC_NAMES.KNOXVILLE,
];

export const NON_BILLABLE_ACCOUNTS = [
  CLINIC_NAMES.UCH_NORTH,
  CLINIC_NAMES.UCH_SOUTH,
  CLINIC_NAMES.PUEBLO,
  ...COVENANT_ACCOUNTS,
];
